// The improved version of the My Intrivity Application
import { html, css, LitElement } from 'lit-element';
import { unsafeHTML } from 'lit-html/directives/unsafe-html.js';
import { clone, cloneDeep } from 'lodash-es';
import { library, dom } from "@fortawesome/fontawesome-svg-core";   

import './behaviors_app.js';

import { 
    getScore, getIcon, getColor, feedback_mapping 
} from './utility.js'
import { a11yStyles, disclosureButton, uniqueId, accessibleTextColor } from './a11y.js';
import { t, Localized } from './i18n.js';

export class IntrivityStrengthsApp extends Localized(LitElement) {

    static get styles() {
        return [a11yStyles, css`
            /* Was a styled <div>; now a real heading so the report has a
               navigable structure (WCAG 1.3.1, 2.4.6). Black on #808080 is
               5.3:1, which clears AA. */
            .section-header {
                margin: 0 0 5px 0;
                width: 100%;
                box-sizing: border-box;
                color: black;
                font-size: 1.5em;
                font-weight: normal;
                padding: 15px 10px 10px 30px;
                background-color: gray;
            }
            .section-header .disclosure {
                vertical-align: middle;
                margin-left: 8px;
                padding: 4px;
            }
        `];
    }

    static get properties() {
        return {
            domain: { type: Object },
            domain_prefix: { type: String },
            report: { type: Object },
            expanded: { type: Boolean },
            printable: { type: Boolean }
        };
    }

    constructor() {
        super();
        this._panelId = uniqueId('strengths');
        this.expanded = false;
    }

    connectedCallback() {
        super.connectedCallback();
    }

    disconnectedCallback() {
        super.disconnectedCallback();
    }
    
    render() {
        return html`
            <h2 class="section-header" style="break-before: page;">
                ${t('domainDetails.strengths')}
                ${this.printable ? html``: disclosureButton(this.expanded, t('domainDetails.strengths'), this._panelId, () => { this.expanded = !this.expanded; })}
            </h2>
        
            ${this.expanded || this.printable ? html`
                <div id=${this._panelId} style="width: 100%;">

                    <h3 style="font-weight: normal; margin: 40px; margin-bottom: 15px; font-size: 1.5em;">${t('domainDetails.behaviorStrengths')}</h3>
        
                    ${this.domain.level_two.map((characteristic, i) => html`
                        ${characteristic.behaviors.map((behavior, j) => html`
                            <div style="margin: 20px; margin-left: 40px;"><span style="color: ${accessibleTextColor(this.domain.color)}; font-weight: bolder;">${behavior.name.toUpperCase()} | </span> 
                                ${this.domain.level_two[i].behaviors[j].strengths[feedback_mapping[getScore(this.report[this.domain_prefix].level_two[i].behaviors[j].average) - 1]]} 
                            </div>
                        `)}
                    `)}
        
                    <h3 style="font-weight: normal; margin: 40px; margin-bottom: 15px; font-size: 1.5em;">${t('domainDetails.attitudeStrengths')}</h3>
        
                    ${this.report[this.domain_prefix].attitudes.length > 0 ? html`
                        ${this.domain.attitudes.map((attitude, i) => html`
                            <div style="margin: 20px; margin-left: 40px;"><span style="color: ${accessibleTextColor(this.domain.color)}; font-weight: bolder;">${attitude.name.toUpperCase()} | </span>
                                ${this.domain.attitudes[i].strengths[feedback_mapping[getScore(this.report[this.domain_prefix].attitudes[i].average) - 1]]}        
                            </div>                      
                        `)}
                    `: html`<div style="padding-left: 40px;">${t('domainDetails.noData')}</div>`}
        
                </div>    
            `: html``}
        `
    } 
 
}
if (!customElements.get('intrivity-strengths')) customElements.define('intrivity-strengths', IntrivityStrengthsApp);
